module.exports = __webpack_public_path__ + "img/video.2cd70b8.png";